import { useEffect, useState } from 'react';
import { shaOfUri } from '../storage/blobStore.ts';
import { storage } from '../storage/index.ts';

/** Object URL for a stored 'blobs/<sha>' URI (cached per hash for the session). */
export function useBlobUrl(uri: string | null | undefined): string | null {
  const sha = uri ? shaOfUri(uri) : null;
  const [url, setUrl] = useState<string | null>(() => (sha ? (storage().blobs.cachedUrl(sha) ?? null) : null));
  useEffect(() => {
    let alive = true;
    if (!sha) {
      setUrl(null);
      return;
    }
    void storage()
      .blobs.url(sha)
      .then((u) => alive && setUrl(u));
    return () => {
      alive = false;
    };
  }, [sha]);
  return url;
}
